import { LandingNavbar } from "../components/Homepage/landing-navbar"
import Spreadsheet from "../components/Spreadsheet"

const SpreadsheetPage = () => {
    return (
    <main className="h-full bg-[#111827] overflow-auto">
        <div className="mx-auto max-w-screen-xl h-full w-full">
            <LandingNavbar />
            <Spreadsheet />
        </div>
      </main>
    )
}

export default SpreadsheetPage